import { Component, inject, PLATFORM_ID } from '@angular/core';
import { brandColor, brandAlpha } from '../../services/theme';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, ChartModule],
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboard.css'],
})
export class Dashboard {
  readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  // ---- Demo stat cards ----
  readonly stats = [
    { label: 'Total Policies', value: '8,420', delta: '+12.5%', up: true, icon: 'pi pi-shield', color: brandColor() },
    { label: 'Active Partners', value: '312', delta: '+4.2%', up: true, icon: 'pi pi-users', color: '#2563eb' },
    { label: 'Claims (This Month)', value: '1,184', delta: '-3.1%', up: false, icon: 'pi pi-file', color: '#d97706' },
    { label: 'Revenue', value: '₹42.6L', delta: '+8.9%', up: true, icon: 'pi pi-indian-rupee', color: '#16a34a' },
  ];

  // ---- Demo chart data ----
  lineData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
    datasets: [
      {
        label: 'Policies Sold',
        data: [320, 410, 380, 520, 610, 700, 840],
        fill: true,
        tension: 0.4,
        borderColor: brandColor(),
        backgroundColor: brandAlpha(0.12),
        pointBackgroundColor: brandColor(),
      },
      {
        label: 'Claims',
        data: [120, 150, 130, 170, 160, 200, 184],
        fill: false,
        tension: 0.4,
        borderColor: '#d97706',
        backgroundColor: 'rgba(217, 119, 6, 0.12)',
        pointBackgroundColor: '#d97706',
      },
    ],
  };

  barData = {
    labels: ['Health', 'Life', 'Motor', 'Travel', 'Home'],
    datasets: [
      {
        label: 'Premium (₹L)',
        data: [18, 12, 9, 4, 6],
        backgroundColor: [brandColor(), '#2563eb', '#d97706', '#16a34a', '#9333ea'],
        borderRadius: 8,
      },
    ],
  };

  doughnutData = {
    labels: ['Health', 'Life', 'Motor', 'Others'],
    datasets: [
      {
        data: [45, 25, 20, 10],
        backgroundColor: [brandColor(), '#2563eb', '#d97706', '#9ca3af'],
        hoverBackgroundColor: [brandColor('--brand-dark'), '#1d4ed8', '#b45309', '#6b7280'],
      },
    ],
  };

  chartOptions = {
    maintainAspectRatio: false,
    plugins: { legend: { labels: { color: '#475569', usePointStyle: true } } },
    scales: {
      x: { ticks: { color: '#64748b' }, grid: { color: '#eef2f6' } },
      y: { ticks: { color: '#64748b' }, grid: { color: '#eef2f6' } },
    },
  };

  doughnutOptions = {
    maintainAspectRatio: false,
    cutout: '62%',
    plugins: { legend: { position: 'bottom', labels: { color: '#475569', usePointStyle: true } } },
  };
}
